import { BlockProps } from "../../containers/Block";

type ContentData = {
  announcements?: Array<{
    link: string;
    title: string;
    content: string;
  }>;
};

export default function Content({ block, zone }: BlockProps) {
  const blockData = JSON.parse(block.data ?? "{}") as ContentData;
  return (
    <div className="grid gap-3 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
      {blockData.announcements?.map((announcement) => (
        <div
          key={announcement.link}
          className="card w-96 bg-neutral text-neutral-content"
        >
          <div className="card-body">
            <h2 className="card-title">{announcement.title}</h2>
            {announcement.content}
            <div className="card-actions mt-2 justify-end">
              <a className="btn bg-primary" href={announcement.link}>
                Link
              </a>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
